/** Datadog RUM application credentials for fin-prequalifications-host. */
export const DATADOG_RUM_APPLICATION = {
  applicationId: "53b3df93-17eb-452e-ae65-423d760e4284",
  clientToken: "pub13fff59997c70d949741a0f3de794b62",
} as const;

export const DATADOG_RUM_SERVICE_NAME = "fin-prequalifications-host";
